var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconFavouriteRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.45 12 26.25 26.25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADFE6",
    d: "M25.576,38.25c-7.237,0-13.125-5.888-13.125-13.125S18.339,12,25.576,12s13.125,5.888,13.125,13.125 S32.813,38.25,25.576,38.25z M25.576,13.25c-6.548,0-11.875,5.327-11.875,11.875S19.028,37,25.576,37s11.875-5.327,11.875-11.875 S32.124,13.25,25.576,13.25z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_2_",
    transform: "translate(1746.021 249.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_2_",
    transform: "translate(0.005 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0066",
    d: "M-1724.699-217.584c-0.004,0-0.008,0-0.013,0c-0.169-0.011-0.314-0.062-0.437-0.151 c-0.256-0.185-0.376-0.52-0.294-0.83l1.127-4.375l-3.478-2.88c-0.25-0.2-0.348-0.548-0.237-0.858 c0.086-0.282,0.355-0.498,0.678-0.522l4.514-0.276l1.66-4.204c0.097-0.2,0.216-0.319,0.365-0.397 c0.19-0.096,0.405-0.113,0.605-0.048c0.201,0.065,0.364,0.206,0.458,0.396l1.674,4.243l4.513,0.286c0,0,0.001,0,0.002,0 c0.312,0.02,0.588,0.227,0.693,0.524c0.101,0.328,0.004,0.652-0.236,0.854l-3.491,2.883l1.128,4.377 c0.057,0.188,0.026,0.419-0.091,0.609c-0.233,0.369-0.718,0.479-1.08,0.25l-3.818-2.429l-3.812,2.426 C-1724.371-217.642-1724.572-217.584-1724.699-217.584z M-1716.681-218.265c0.003,0.013,0.006,0.025,0.01,0.038 L-1716.681-218.265z M-1724.23-218.256l-0.002,0.007C-1724.232-218.252-1724.231-218.254-1724.23-218.256z M-1724.934-218.766 c-0.006,0.004-0.011,0.008-0.017,0.011L-1724.934-218.766z M-1720.457-221.499c0.116,0,0.233,0.032,0.336,0.098l3.147,2.003 l-0.932-3.614c-0.061-0.235,0.021-0.483,0.207-0.638l2.88-2.379l-3.733-0.236c-0.241-0.016-0.453-0.17-0.541-0.395l-1.362-3.457 l-1.367,3.469c-0.089,0.226-0.301,0.38-0.543,0.395l-3.718,0.228l2.87,2.376c0.187,0.154,0.268,0.402,0.207,0.638l-0.931,3.612 l3.144-2.001C-1720.69-221.467-1720.573-221.499-1720.457-221.499z M-1713.617-225.953c0.001,0,0.001,0,0.002,0 C-1713.616-225.953-1713.616-225.953-1713.617-225.953z M-1727.003-226.789l0.011,0.009 C-1726.996-226.783-1726.999-226.786-1727.003-226.789z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#DADFE6",
    strokeWidth: 1.25,
    cx: 25.576,
    cy: 25.125,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_1_",
    transform: "translate(1746.021 249.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_1_",
    transform: "translate(0.005 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_51_1_",
    fill: "none",
    stroke: "#818994",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M-1713.603-226.579l-4.908-0.311l-1.797-4.562c-0.04-0.08-0.138-0.112-0.218-0.072c-0.031,0.016-0.056,0.041-0.072,0.072 l-1.806,4.575l-4.902,0.299c-0.064,0.005-0.118,0.048-0.137,0.109c-0.021,0.06-0.002,0.128,0.047,0.168l3.783,3.133 l-1.227,4.764c-0.016,0.062,0.008,0.127,0.059,0.165c0.026,0.019,0.056,0.029,0.087,0.031c0.031,0,0.061-0.008,0.087-0.025 l4.147-2.64l4.151,2.641c0.073,0.046,0.169,0.024,0.215-0.048c0.024-0.037,0.03-0.083,0.018-0.126l-1.227-4.761l3.792-3.133 c0.049-0.041,0.068-0.107,0.05-0.168c-0.022-0.064-0.082-0.107-0.149-0.109H-1713.603z"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconFavouriteRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-favourite-red.ab1ee8ff.svg";
export { ForwardRef as ReactComponent };